import { Pencil } from "@tamagui/lucide-icons";
import { observer } from "mobx-react-lite";
import React from "react";
import { YStack } from "tamagui";
import { PlanHotelsTipsUI } from "../../../affiliates/booking/PlanHotelsTipsUI";
import { useLoadUsersInPlan } from "../../../core/hooks/useLoadUsersInPlan";
import { trackEvent } from "../../../core/trackEvent";
import type PlanModel from "../../../plans/PlanModel";
import { PlanQuickstartAddGeneralStep } from "../../../plans/PlanQuickstartAddStep";
import { OverviewListContent } from "../../../plans/PlanQuickstartOverview";
import { PlanUsersWaitingForApproval } from "../../../plans/PlanUsersWaitingForApproval";
import { AddCardSheet } from "../../../sections/AddCardSheet";
import { TitleTextarea } from "../../../ui/Title";
import { UserAvatarGroup } from "../../../ui/UserAvatarGroup";
import { useBusinessTeamSection } from "./useBusinessTeamModules";

export const PlanBusinessOverview = observer(
  ({ plan }: { plan: PlanModel }) => {
    const section = useBusinessTeamSection();

    useLoadUsersInPlan(plan.uid);

    const showAffilateBar = plan?.hasLocationModule;

    if (!section) {
      return null;
    }

    return (
      <YStack gap="$medium">
        <UserAvatarGroup
          onPress={() => {
            plan.setShowShare(true, true);
            trackEvent("user_avatar_group_clicked");
          }}
          userUids={plan.data.userIds}
        />

        <YStack
          gap="$small"
          flexWrap={"nowrap"}
          paddingHorizontal="$larger"
          $gtSm={{ paddingHorizontal: 0 }}
        >
          <TitleTextarea
            icon={Pencil}
            focusOnIconPress
            defaultValue={plan.data.title ?? ""}
            submitOnBlur
            submitOnEnter
            blurOnSubmit
            onSubmitEditing={(e) => {
              void plan.setTitle(e.nativeEvent.text);
            }}
          />
        </YStack>

        <PlanUsersWaitingForApproval plan={plan} />

        <OverviewListContent plan={plan} section={section} />

        <PlanQuickstartAddGeneralStep plan={plan} />

        {showAffilateBar && <PlanHotelsTipsUI plan={plan} />}

        {section && (
          <AddCardSheet
            section={section}
            open={plan.showAddStepSheet}
            onOpenChange={(visible: boolean) =>
              plan.setShowAddStepSheet(visible)
            }
          />
        )}
      </YStack>
    );
  },
);
